<template>
  <div class="hot-page">
    <div v-if="developList.length" class="section">
      <div class="section-title">热门问题</div>
      <div class="card-list">
        <div v-for="item in developList" :key="item.id" class="card">
          <div class="card-title">{{ item.name }}</div>
          <div v-if="item.child && item.child.length" class="card-items">
            <span
              v-for="info in item.child"
              :key="info.id"
              class="card-item"
              @click="handleJump('develop', info)"
            >{{ info.name }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="section-title">新手引导</div>
      <div class="card-list">
        <div v-for="item in beginnerList" :key="item.id" class="card">
          <div class="card-title">{{ item.name }}</div>
          <div v-if="item.child && item.child.length" class="card-items">
            <span
              v-for="info in item.child"
              :key="info.id"
              class="card-item"
              @click="handleJump('beginner', info)"
            >{{ info.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      developList: [],
      beginnerList: [
        {
          id: '4', name: '新手必读', child: [
            { id: 'openness_quickGame', name: '快游戏介绍' },
            { id: 'doc_register', name: '账号注册' },
          ]
        },
        {
          id: '1', name: '快游戏接入', child: [
            { id: 'doc_cocos', name: 'Cocos&Laya接入' },
            { id: 'doc_unity', name: 'Unity接入' },
          ]
        },
        {
          id: '2', name: '开发文档', child: [
            { id: 'doc_api', name: 'API接口' },
            { id: 'doc_ad', name: '广告接入' },
          ]
        },
        {
          id: '3', name: '开发工具', child: [
            { id: 'ide_download', name: 'IDE下载' },
            { id: 'debugger_download', name: '调试器下载' },
          ]
        },
      ],
    }
  },
  created() {
    this.getRecommend()
  },
  methods: {
    getRecommend() {
      this.$apis.gameProblemServer.recommend().then(res => {
        if (res.code === 0) {
          this.developList = res.data.dataList
        }
      })
    },
    handleJump(type, item) {
      if (type === 'beginner') {
        const links = {
          openness_quickGame: '/openness/quickGame',
          doc_register: 'https://doc.quickapp.cn/',
          doc_cocos: 'https://doc.quickapp.cn/',
          doc_unity: 'https://doc.quickapp.cn/',
          doc_api: 'https://doc.quickapp.cn/',
          doc_ad: 'https://doc.quickapp.cn/',
          ide_download: 'https://quickgame-ide.cnbj1.mi-fds.com/quickgame-ide/index.html',
          debugger_download: 'https://doc.quickapp.cn/',
        }
        window.open(links[item.id] || 'https://doc.quickapp.cn/', '_blank')
      } else {
        this.$router.push(`/commonGameProblem/faq/${item.id}`)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.hot-page {
  padding: 30px;
}
.section {
  margin-bottom: 40px;
  &-title {
    font-size: 34px;
    font-weight: 700;
    color: #333;
    margin-bottom: 24px;
    padding-left: 20px;
    position: relative;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 6px;
      height: 30px;
      background: linear-gradient(180deg, #5A88FF, #3D6BE5);
      border-radius: 3px;
    }
  }
}
.card-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.card {
  background: #fff;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  transition: box-shadow 0.3s;
  &-title {
    font-size: 30px;
    font-weight: 700;
    color: #333;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    &::before {
      content: '';
      display: inline-block;
      width: 8px;
      height: 28px;
      background: linear-gradient(180deg, #5A88FF, #3D6BE5);
      border-radius: 4px;
      margin-right: 12px;
      flex-shrink: 0;
    }
  }
  &-items {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
  }
  &-item {
    display: inline-block;
    padding: 14px 24px;
    font-size: 26px;
    color: #555;
    background: #f5f7fb;
    border-radius: 10px;
    border: 1px solid #eef1f5;
    transition: all 0.25s;
    &:active {
      background: #edf3ff;
      border-color: #5A88FF;
      color: #5A88FF;
    }
  }
}
</style>
